'use client'

import { useMediaQuery } from '@patrianna/shared-hooks'

import BackButtonLink from 'src/components/BackButtonLink'
import BuilderTextContent from 'src/components/BuilderTextContent'
import useBackUrl from 'src/hooks/useBackUrl'
import useRestoreRegConfirm from 'src/hooks/useRestoreRegConfirm'

export default function RightToOptOut(props: { content: any; builderPage: string; backHref?: string }) {
  useRestoreRegConfirm()
  const backUrl = useBackUrl({ backHref: props.backHref })
  const isMobile = useMediaQuery('xs')

  return (
    <>
      {isMobile && <BackButtonLink href={backUrl} />}
      <BuilderTextContent content={props.content} model={props.builderPage} />
    </>
  )
}
